export enum Res {
  Percentage = 'percentage',
  Pixels = 'pixels'
}
